import { render, staticRenderFns } from "./EditOrderItemToggle.vue?vue&type=template&id=4b7538a7&scoped=true"
import script from "./EditOrderItemToggle.vue?vue&type=script&lang=js"
export * from "./EditOrderItemToggle.vue?vue&type=script&lang=js"
import style0 from "./EditOrderItemToggle.vue?vue&type=style&index=0&id=4b7538a7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b7538a7",
  null
  
)

export default component.exports